import classNames from 'classnames'
import { JSX } from 'react'

import { FormRichTextEditor } from 'cng-common/features/form/components/formRichTextEditor/FormRichTextEditor'
import { IFormRichTextEditor } from 'cng-common/features/form/components/formRichTextEditor/models'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: IFormRichTextEditor) => JSX.Element | null

const applyDisabled = (component: TComponentFn) => {
  return (props: IFormRichTextEditor) => {
    const { isDisabled, className } = props
    const disabledTheme = isDisabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      className: classNames(className, disabledTheme),
    })
  }
}

export const OnboardingFormRichTextEditor = (props: IFormRichTextEditor) =>
  applyDisabled(
    createComponentFn<IFormRichTextEditor & JSX.IntrinsicAttributes>(FormRichTextEditor)
  )(props)
